<div
  class="circle"
  [ngStyle]="{'background-color': circleColor, '--size': width + 'px'}"
>
  <img *ngIf="!showInitials" src="{{ photoUrl }}" />

  <div *ngIf="showInitials" class="initials">
    {{ initials }}
  </div>
</div>
